import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看");

import { ref } from 'vue';
import { getRecruitPersonnelList, getRecruitPersonnelDetail } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'RecruitPersonnelList',

  setup(__props) {
    const form = ref({
      linkMan: '',
      linkPhone: ''
    });
    const table = ref();
    const showDetail = ref(false);
    const detail = ref(null);
    const tableOptions = getVexTableProps({
      columns: [{
        field: 'linkMan',
        title: '姓名',
        width: '100px'
      }, {
        field: 'gender',
        title: '性别',
        width: '80px'
      }, {
        field: 'linkPhone',
        title: '手机号',
        width: '130px'
      }, {
        field: 'regionSummary',
        title: '业务区域',
        minWidth: '160px',
        showOverflow: true
      }, {
        field: 'channelSummary',
        title: '擅长渠道',
        minWidth: '160px',
        showOverflow: true
      }, {
        field: 'loginName',
        title: '登录账号',
        width: '130px',
        showOverflow: true
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '170px'
      }, {
        title: '操作',
        width: '100px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRecruitPersonnelList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        linkMan: '',
        linkPhone: ''
      };
      table.value.commitProxy('reload');
    }

    function seeDetail(row) {
      getRecruitPersonnelDetail({
        personnelId: row.personnelId
      }).then(res => {
        detail.value = res.data;
        showDetail.value = true;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      const _component_el_descriptions = _resolveComponent("el-descriptions");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "姓名"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "手机号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkPhone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkPhone = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "success",
          onClick: $event => seeDetail(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: showDetail.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showDetail.value = $event),
        title: "资源池人员详情",
        width: "600px"
      }, {
        default: _withCtx(() => [detail.value ? (_openBlock(), _createBlock(_component_el_descriptions, {
          key: 0,
          column: 1,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "姓名"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.linkMan), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "性别"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.gender), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "手机号"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.linkPhone), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "登录账号"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.loginName || '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "微信昵称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.wechatNickName || '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "业务区域"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString((detail.value.areaList || []).map(a => a.text).join('、') || '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "擅长渠道"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString((detail.value.channelList || []).map(c => c.text).join('、') || '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "登记时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.createAt), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "更新时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.updateAt), 1)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};